import { useDesigns } from '@customink/project-service-react-components';

export const useHasMultipleDesigns = () => {
  const designsById = useDesigns();
  const designs = Object.values(designsById);
  return designs.length > 1;
};
